export const vessels = {
  DEFAULT: {
    image: 'defaultship.png'
  },
  ARN: {
    name: 'Arnarfell',
    service: 'Iceland',
    imo_nr: '9306005',
    type: 'Geared Container vessel',
    teu: 909,
    dwt: 11143,
    speed: 18.2,
    build_year: 2005,
    engine_kw: 8400,
    length: 137.5,
    draft: 8.5,
    image: 'arnarfell-nalaegt.jpg'
  },
  HEG: {
    name: 'Helgafell',
    service: 'Iceland',
    imo_nr: 9306017,
    type: 'Geared Container vessel',
    teu: 909,
    dwt: 11143,
    speed: 18.2,
    build_year: 2005,
    engine_kw: 8400,
    length: 137.53,
    draft: 8.5,
    image: 'Helgafellid-i-eyjum-okt.2015.jpg'
  },
  SKF: {
    name: 'Samskip Skaftafell',
    service: 'Iceland',
    imo_nr: 9164562,
    type: 'Geared Container vessel',
    teu: 518,
    dwt: 5584,
    speed: 15.0,
    build_year: 2000,
    engine_kw: 4320,
    length: 100.6,
    draft: 6.7,
    image: 'skaftafell.jpg'
  },
  HOF: {
    name: 'Samskip Hoffell',
    service: 'Iceland',
    imo_nr: 9164550,
    type: 'Geared Container vessel',
    teu: 502,
    dwt: 5536,
    speed: 15.0,
    build_year: 2000,
    engine_kw: 4320,
    length: 100.6,
    draft: 6.7,
    image: 'SAMSKIP_HOFFELL2017.png'
  },
  SAE: {
    name: 'Saefari',
    service: 'Iceland',
    imo_nr: 9041277,
    type: 'Passenger cargo',
    teu: 'N/A',
    dwt: 225,
    speed: 13.0,
    build_year: 1992,
    engine_kw: 2040,
    length: 39.7,
    draft: 2.5,
    image: 'saefari-scaled.jpg'
  },
  END: {
    name: 'Samskip Endeavour',
    service: 'Multimodal',
    imo_nr: 9436290,
    type: 'Container vessel',
    teu: 812,
    dwt: 9315,
    speed: 18.0,
    build_year: 2011,
    engine_kw: 8400,
    length: 140.6,
    draft: 7.3,
    image: 'endeavour-skip.JPG'
  },
  INN: {
    name: 'Samskip Innovator',
    service: 'Multimodal',
    imo_nr: 9436214,
    type: 'Container vessel',
    teu: 803,
    dwt: 9350,
    speed: 18.0,
    build_year: 2011,
    engine_kw: 8400,
    length: 140.6,
    draft: 7.3,
    image: 'samskipinnovator.jpg'
  },
  COU: {
    name: 'Samskip Courier',
    service: 'Multimodal',
    imo_nr: 9322578,
    type: 'Container vessel',
    teu: 804,
    dwt: 9340,
    speed: 18.0,
    build_year: 2006,
    engine_kw: 8400,
    length: 140.6,
    draft: 7.3,
    image: 'courier.jpg'
  },
  HEN: {
    name: 'Henrike Schepers',
    service: 'Multimodal',
    imo_nr: 9404091,
    type: 'Container vessel',
    teu: 800,
    dwt: 9231,
    speed: 18.0,
    build_year: 2008,
    engine_kw: 8400,
    length: 140.6,
    draft: 7.3,
    image: 'HENRIKE_SCHEPERS.png'
  },
  BER: {
    name: 'Berta',
    service: 'Multimodal',
    imo_nr: 9184225,
    type: 'Container vessel',
    teu: 630,
    dwt: 7400,
    speed: 16.5,
    build_year: 2004,
    engine_kw: 5200,
    length: 118.3,
    draft: 8.1,
    image: 'BERTA.png'
  },
  COM: {
    name: 'ECL Commander',
    service: 'Multimodal',
    imo_nr: 9143829,
    type: 'Container vessel',
    teu: 387,
    dwt: 4762,
    speed: 15.5,
    build_year: 1997,
    engine_kw: 3520,
    length: 100.6,
    draft: 5.9,
    image: 'ECL_COMMANDER.png'
  },
  EXP: {
    name: 'Samskip Express',
    service: 'Multimodal',
    imo_nr: 9323479,
    type: 'Container vessel',
    teu: 803,
    dwt: 9313,
    speed: 18,
    build_year: 2006,
    engine_kw: 8400,
    length: 140.6,
    draft: 7.3,
    image: 'SAMSKIP_EXPRESS.png'
  },
  CHA: {
    name: 'ELC Challenger',
    service: 'Multimodal',
    imo_nr: 9114787,
    type: 'Container vessel',
    teu: 387,
    dwt: 4766,
    speed: 15.0,
    build_year: 1995,
    engine_kw: 3300,
    length: 100.7,
    draft: 5.9,
    image: 'ECL_CHALLENGER.png'
  },
  MAR: {
    name: 'Marus',
    service: 'Multimodal',
    imo_nr: 9110559,
    type: 'Container vessel',
    teu: 340,
    dwt: 3950,
    speed: 14.0,
    build_year: 1996,
    engine_kw: 3380,
    length: 99.3,
    draft: 4.9,
    image: 'MARUS.png'
  },
  BLA: {
    name: 'Bláfell',
    service: '-',
    imo_nr: 0,
    type: 'Container vessel',
    teu: 0,
    dwt: 0,
    speed: 0,
    build_year: 0,
    engine_kw: 0,
    length: 0,
    draft: 0,
    image: ''
  },
  SKA: {
    name: 'Skálafell',
    service: '-',
    imo_nr: 0,
    type: 'Container vessel',
    teu: 0,
    dwt: 0,
    speed: 0,
    build_year: 0,
    engine_kw: 0,
    length: 0,
    draft: 0,
    image: 'skalafell.jpg'
  }
};



// WEBPACK FOOTER //
// ./src/data/vessels.js